import {MAX_GAME_DURATION_MINUTES, MIN_GAME_DURATION_MINUTES,} from '../pages/games/PlayoffSchedule/playoffSchedulingConstants';

export interface TimeValidationResult {
  isValid: boolean;
  error?: string;
}

export const formatDateTimeLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const validateTimes = (
  startTime: string,
  endTime: string
): TimeValidationResult => {
  if (!startTime || !endTime) {
    return {
      isValid: false,
      error: 'Both start and end times are required',
    };
  }

  const startDate = new Date(startTime);
  const endDate = new Date(endTime);
  const now = new Date();

  if (startDate < now) {
    return {
      isValid: false,
      error: 'Start time cannot be in the past',
    };
  }

  if (endDate <= startDate) {
    return {
      isValid: false,
      error: 'End time must be after start time',
    };
  }

  const durationMinutes = (endDate.getTime() - startDate.getTime()) / (1000 * 60);

  if (durationMinutes < MIN_GAME_DURATION_MINUTES) {
    return {
      isValid: false,
      error: `Game duration must be at least ${MIN_GAME_DURATION_MINUTES} minutes`,
    };
  }

  if (durationMinutes > MAX_GAME_DURATION_MINUTES) {
    return {
      isValid: false,
      error: `Game duration cannot exceed ${MAX_GAME_DURATION_MINUTES / 60} hours`,
    };
  }

  return {isValid: true};
};

export const getTimeDuration = (startTime: string, endTime: string): string => {
  if (!startTime || !endTime) return '';

  const start = new Date(startTime);
  const end = new Date(endTime);
  const durationMinutes = (end.getTime() - start.getTime()) / (1000 * 60);

  if (durationMinutes < 60) {
    return `${durationMinutes} minutes`;
  }

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  return minutes > 0
    ? `${hours}h ${minutes}m`
    : `${hours} hour${hours > 1 ? 's' : ''}`;
};

export const getRoundedStartTime = (roundingMinutes: number): Date => {
  const now = new Date();
  const minutes = now.getMinutes();
  const roundedMinutes = Math.ceil(minutes / roundingMinutes) * roundingMinutes;
  now.setMinutes(roundedMinutes, 0, 0);
  return now;
};
